import React from 'react';
import { Icon, Select, Input, Tooltip, Popover, Button, AutoComplete, message } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';

const { Option } = Select;

export class CreateNewCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            companycategories: [],
            user: this.props.user,
            catName: null,
            catSaved: false,
            parentName: null,
            parentId: null,
            categories: [],
            catId: '',
            catCreated: false,
            catSameName: [],
            visible: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.saveCat = this.saveCat.bind(this);
        this.handleParent = this.handleParent.bind(this);
        this.catNameWritten = this.catNameWritten.bind(this);
        this.sendCatSaved = this.sendCatSaved.bind(this);
        this.checkName = this.checkName.bind(this);
        this.hide = this.hide.bind(this);
        this.saveCatAnyway = this.saveCatAnyway.bind(this);

        document.title = "Polar - Categories"

        //categorie
        fetch(
            `${SERVER_URL + 'api/companycategory/list'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "name": '',
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 80,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    let categories = []
                    res.data.map(cat => {
                        if (cat.companyCategoryParent == null) {
                            categories.push({ id: cat.catId, name: cat.name })
                        }
                    })
                    this.setState({ categories: categories });
                } else {
                    this.setState({ categories: [] });
                }

            })
    }

    handleNameChange(event) {
        this.setState({ catName: event.target.value, catSaved: false, catSameName: [] });

        if (event.target.value.length === 0) {
            this.setState({ catName: null })
        }
    }

    handleParent(value) {
        this.setState({ parentId: value, catSaved: false })
    }

    catNameWritten(value) {
        this.setState({ parentName: value });
    }

    saveCat() {
        if (this.state.catCreated) {
            fetch(`${SERVER_URL + 'api/CompanyCategory'}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`,
                },
                body: JSON.stringify({
                    'Name': this.state.catName,
                    'CompanyCategoryParentCatId': this.state.parentId,
                    "catId": this.state.catId,
                    "Status": 1
                })
            }).then(this.setState({ catSaved: true }))
        } else if (this.state.catSameName.length == 0) {
            fetch(`${SERVER_URL + 'api/CompanyCategory'}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`,
                },
                body: JSON.stringify({
                    'Name': this.state.catName,
                    'CompanyCategoryParentCatId': this.state.parentId,
                    "Status": 1,
                })
            }).then(response => response.json())
                .then(res => {
                    this.setState({ catId: res.data, catSaved: true, catCreated: true })
                    this.sendCatSaved()
                })
        } 
    }

    saveCatAnyway() {
        fetch(`${SERVER_URL + 'api/CompanyCategory'}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`,
            },
            body: JSON.stringify({
                'Name': this.state.catName,
                'CompanyCategoryParentCatId': this.state.parentId,
                "Status": 1,
            })
        }).then(response => response.json())
            .then(res => {
                this.setState({ catId: res.data, catSaved: true, catCreated: true })
                this.sendCatSaved()
            })
    } 

    sendCatSaved = () => {
        this.props.parentCallbackCatSaved(true);
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    };

    checkName() {
        if (this.state.catName != null) {
            if (this.state.catName.length > 1) {
                fetch(
                    `${SERVER_URL + 'api/CompanyCategory/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "uniqueName": this.state.catName,
                        "page": 1,
                        "pageSize": 15,
                        "Status": 1
                    })
                }
                ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        message.warning('Name already in use')
                        this.setState({ catSameName: res.data, visible: true })
                    }
                })
            }
        }
    }

    choosecat(cat) {
        this.setState({ catId: cat.catId, catName: cat.name, catCreated: true, visible: false })
    }

    render() {

        let mandatoryName = this.state.catName != null ? <Icon style={{ marginTop: '12px', marginLeft: '15px' }} type="check-circle" /> : <Tooltip title="This field is mandatory"><Icon style={{ marginTop: '12px', marginLeft: '15px' }} type="exclamation-circle" /></Tooltip>

        let catSave = this.state.catSaved ? <div className="saveButtonBox"><Popover content="The Category is already saved"><Button disabled className="saveButtonHrWizard" icon="save">Save Category</Button></Popover></div> : this.state.catName != null ? <div className="saveButtonBox"> <Button onClick={this.saveCat} className="saveButtonHrWizard" icon="save">Save Category</Button></div> : <div className="saveButtonBox"><Popover content="A name is needed in order to save the Category"><Button disabled className="saveButtonHrWizard" icon="save">Save Category</Button></Popover></div>

        let listacat = this.state.categories.map(cat =>            
                <Option key={cat.id}>{cat.name}</Option>            
        )

        return (

            <div className="modifyHrBox" style={{ width: '100%' }}>
                <div className={"modifyHr" + this.state.catSaved} style={{ width: '100%' }}>
                    <div style={{ width: '100%', display: 'inline-flex' }}>
                        <div style={{ width: '48%' }}>
                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                <Tooltip placement="topLeft" title="If the new Category has a Parent Category, select it here. Child Categories cannot be Parent Cateogories">
                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Parent Category:</h4>
                                </Tooltip>
                            </div>
                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                <AutoComplete
                                    dataSource={listacat}
                                    placeholder="Parent Category"
                                    style={{ width: '100%' }}
                                    onSelect={this.handleParent}
                                    onSearch={this.catNameWritten}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                />
                            </div>
                        </div>
                        <div style={{ width: '48%', marginLeft: '4%' }}>
                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                <Tooltip placement="topLeft" title="Insert here the New Category name">
                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Category Name:</h4>
                                </Tooltip>
                            </div>
                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                <Input autoComplete="new-password" style={{ width: '100%' }} onBlur={this.checkName} className="contactText hrNameValidation" allowClear={true} placeholder="Category name" onChange={this.handleNameChange} />
                                {mandatoryName}
                            </div>
                        </div>
                    </div>
                    {catSave}
                </div>
            </div>

        )
    }
}

export default CreateNewCategory;


// WEBPACK FOOTER //
// ./src/CompanyCategory/CreateNewCategory.js